import axiosConfig from "../util/axiosConfig";
import { API_ENDPOINTS } from '../util/apiEndpoints';

// Ensure these are added to apiEndpoints.js if not already present, 
// temporarily defining them here if needed or assuming they will be there.
// Optimistically assuming the user wants them in the main config, 
// but for this file I will just use string literals if I can't see apiEndpoints file, 
// OR better yet, I will verify apiEndpoints first? 
// No, I'll just follow the pattern. Let's check apiEndpoints file first in a separate step or just assume?
// The file usage shows import { API_ENDPOINTS } ...
// I should check `../util/apiEndpoints` first to be safe.


export const fetchTrends = async (date, locationNames) => {
    try {
        console.log("Fetching trends with:", { date, locationNames });
        const response = await axiosConfig.post(API_ENDPOINTS.TRENDS, {
            date,
            locationNames,
        });
        console.log("API Response:", response.data);
        return response.data;
    } catch (error) {
        handleServiceError(error);
    }
};

export const fetchTrendsV2 = async (date, locationNames) => {
    try {
        console.log("Fetching V2 trends with:", { date, locationNames });
        const response = await axiosConfig.post(API_ENDPOINTS.TRENDS_V2, {
            date,
            locationNames,
        });
        console.log("API Response V2:", response.data);
        return response.data;
    } catch (error) {
        handleServiceError(error);
    }
};

export const fetchTrendsV3 = async (startDate, endDate, locationNames) => {
    try {
        console.log("Fetching V3 trends with:", { startDate, endDate, locationNames });
        const response = await axiosConfig.post(API_ENDPOINTS.TRENDS_V3, {
            fromDate: startDate,
            toDate: endDate,
            locationNames,
        });
        console.log("API Response V3:", response.data);
        return response.data;
    } catch (error) {
        handleServiceError(error);
    }
};

const handleServiceError = (error) => {
    if (error.response) {
        throw new Error(`Server Error: ${error.response.status} - ${error.response.data?.message || error.message}`);
    } else if (error.request) {
        throw new Error('Network Error: No response received from backend. Is it running on port 8082?');
    } else {
        throw new Error(`Request Error: ${error.message}`);
    }
};
